import src from "IMAGE";
export default { src, width: 880, height: 440, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAANUlEQVR42lXMMQoAIAwDwP7/ny06NENAcLREFHpLAoGYS0QM8cduZOYSAG0guaVKG+pkyn87EGFXc8Fv/xAAAAAASUVORK5CYII="};
